<template>
	<div>
    <template v-if="!success">
      <b-form-group
        :state="errors.first('username') ? false : true"
        :invalid-feedback="errors.first('username')"
        label="Ingresa tu nombre de usuario" label-for="username"
        description="Para recuperar tu contraseña es necesario verificar tu nombre de usuario, te enviaremos un correo electrónico con un link para recuperar tu contraseña."
      >
        <b-form-input
          :state="errors.first('username') ? false : null"
          v-validate="'required'"
          @keyup="errorMessage = ''"
          v-model="username"
          name="username"
          id="username"
          type="text"
        />
      </b-form-group>

      <div class="alert alert-danger" role="alert" v-show="errorMessage">
        {{errorMessage}}
      </div>

      <div class="row pr-3 d-flex justify-content-end">
        <b-button :disabled="submitted" @click="validateBeforeSubmit" variant="primary" class="cursor-pointer">
          <img src="../assets/spinner.gif" width="20rem" v-show="submitted">
          Recuperar Contraseña
        </b-button>
      </div>
    </template>
    <template v-else>
      <div class="alert alert-success" role="alert">
        Se ha enviado un correo electrónico con el link para cambiar tu contraseña.
      </div>
      <div class="row pr-3 d-flex justify-content-end">
        <b-button variant="primary" class="cursor-pointer" @click="success = false">
          ← Volver a solicitar
        </b-button>
      </div>
    </template>
    

	</div>
</template>

<script>
import axios from 'axios';
import utils from '../other/utils.js';

export default {
  name: 'home',
  data () {
    return {
      username: '',
      submitted: false,
      errorMessage: '',
      success: false
    };
  },
  methods: {
    async validateBeforeSubmit ()	{
			try {
        this.submitted = true;

				let validationResult = await this.$validator.validateAll();
        if (!validationResult) return;

        let body = {
          username: this.username
        };

        let response = await axios.post('users/request-password', body);
        this.success = true;

			} catch (error) {
        this.errorMessage = utils.getHumanErrorMessage(error, 'USERS');
			} finally {
				this.submitted = false;
      }
		}
  }
};
</script>

<style>
.date {
    background-color: white !important;
    opacity: 1 !important;
		margin-right: .5rem;
}

.vdp-datepicker {
  margin-right: .5rem;
}
</style>



// WEBPACK FOOTER //
// Home.vue?7917860e